import { useEffect, useState } from 'react';

// Czy zapytanie @media pasuje teraz, z odświeżeniem przy zmianie (obrót tabletu, zmiana szerokości
// okna). Bez `matchMedia` (stare przeglądarki, część testów) zawsze false, czyli wersja dla myszy.
const pasujeTeraz = (zapytanie) => (
  typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(zapytanie).matches
);

export default function useMediaQuery(zapytanie) {
  const [pasuje, setPasuje] = useState(() => pasujeTeraz(zapytanie));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const mql = window.matchMedia(zapytanie);
    const zmiana = () => setPasuje(mql.matches);
    zmiana();
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', zmiana);
      return () => mql.removeEventListener('change', zmiana);
    }
    mql.addListener(zmiana);
    return () => mql.removeListener(zmiana);
  }, [zapytanie]);

  return pasuje;
}
